import { PageContainer } from '@if/mui'
import InteracHistoryList from '@src/components/InteracHistory/InteracHistoryList'
import { useTranslation } from 'react-i18next'

const InteracHistoryListPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer
      overline={t('interacHistory.overline')}
      title={t('interacHistory.title')}
      back={{ to: '/interac-wire', label: t('interacWire.reconciliation.title') }}
    >
      <InteracHistoryList />
    </PageContainer>
  )
}

export default InteracHistoryListPage
